import { render, staticRenderFns } from "./offsetReceipt.vue?vue&type=template&id=e19310a4&scoped=true&"
import script from "./offsetReceipt.vue?vue&type=script&lang=js&"
export * from "./offsetReceipt.vue?vue&type=script&lang=js&"
import style0 from "./offsetReceipt.vue?vue&type=style&index=0&id=e19310a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19310a4",
  null
  
)

component.options.__file = "offsetReceipt.vue"
export default component.exports